'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = info;
exports.isLoaded = isLoaded;
exports.load = load;
exports.loadExchangeRates = loadExchangeRates;
exports.loadARL = loadARL;
exports.loadBTS = loadBTS;
exports.loadMRT = loadMRT;
exports.loadLanguages = loadLanguages;
exports.loadForms = loadForms;
exports.loadActivities = loadActivities;
exports.loadUserConfig = loadUserConfig;
exports.loadSiteConfigs = loadSiteConfigs;
exports.loadTopActivities = loadTopActivities;
exports.loadCombinedDynamic = loadCombinedDynamic;
exports.loadCombinedStatic = loadCombinedStatic;
exports.loadPresetActivities = loadPresetActivities;
exports.loadDestinationsSiteMap = loadDestinationsSiteMap;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _trip = require('utils/trip');

var _siteConfigs = require('json/site-configs.json');

var _siteConfigs2 = _interopRequireDefault(_siteConfigs);

var _activities = require('json/activities.json');

var _activities2 = _interopRequireDefault(_activities);

var _headTags = require('json/head-tags.json');

var _headTags2 = _interopRequireDefault(_headTags);

var _destinations = require('json/destinations.json');

var _destinations2 = _interopRequireDefault(_destinations);

var _languages = require('json/languages.json');

var _languages2 = _interopRequireDefault(_languages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_DEST = 'redux-frontend/info/LOAD_DEST';
var LOAD_DEST_SUCCESS = 'redux-frontend/info/LOAD_DEST_SUCCESS';
var LOAD_DEST_FAIL = 'redux-frontend/info/LOAD_DEST_FAIL';

var LOAD_EXCHANGE_RATES = 'redux-frontend/info/LOAD_EXCHANGE_RATES';
var LOAD_EXCHANGE_RATES_SUCCESS = 'redux-frontend/info/LOAD_EXCHANGE_RATES_SUCCESS';
var LOAD_EXCHANGE_RATES_FAIL = 'redux-frontend/info/LOAD_EXCHANGE_RATES_FAIL';

var LOAD_STATIONS = 'redux-frontend/info/LOAD_STATIONS';
var LOAD_STATIONS_SUCCESS = 'redux-frontend/info/LOAD_STATIONS_SUCCESS';
var LOAD_STATIONS_FAIL = 'redux-frontend/info/LOAD_STATIONS_FAIL';

var LOAD_LANGUAGES = 'redux-frontend/info/LOAD_LANGUAGES';
var LOAD_LANGUAGES_SUCCESS = 'redux-frontend/info/LOAD_LANGUAGES_SUCCESS';
var LOAD_LANGUAGES_FAIL = 'redux-frontend/info/LOAD_LANGUAGES_FAIL';

var LOAD_ACTIVITIES = 'redux-frontend/info/LOAD_ACTIVITIES';
var LOAD_ACTIVITIES_SUCCESS = 'redux-frontend/info/LOAD_ACTIVITIES_SUCCESS';
var LOAD_ACTIVITIES_FAIL = 'redux-frontend/info/LOAD_ACTIVITIES_FAIL';

var LOAD_TOP_ACTIVITIES = 'redux-frontend/info/LOAD_TOP_ACTIVITIES';
var LOAD_TOP_ACTIVITIES_SUCCESS = 'redux-frontend/info/LOAD_TOP_ACTIVITIES_SUCCESS';
var LOAD_TOP_ACTIVITIES_FAIL = 'redux-frontend/info/LOAD_TOP_ACTIVITIES_FAIL';

var LOAD_FORMS = 'redux-frontend/info/LOAD_FORMS';
var LOAD_FORMS_SUCCESS = 'redux-frontend/info/LOAD_FORMS_SUCCESS';
var LOAD_FORMS_FAIL = 'redux-frontend/info/LOAD_FORMS_FAIL';

var LOAD_USER_CONFIG = 'redux-frontend/info/LOAD_USER_CONFIG';
var LOAD_USER_CONFIG_SUCCESS = 'redux-frontend/info/LOAD_USER_CONFIG_SUCCESS';
var LOAD_USER_CONFIG_FAIL = 'redux-frontend/info/LOAD_USER_CONFIG_FAIL';

var LOAD_SITE_CONFIGS = 'redux-frontend/info/LOAD_SITE_CONFIGS';
var LOAD_SITE_CONFIGS_SUCCESS = 'redux-frontend/info/LOAD_SITE_CONFIGS_SUCCESS';
var LOAD_SITE_CONFIGS_FAIL = 'redux-frontend/info/LOAD_SITE_CONFIGS_FAIL';

var LOAD_COMBINED_DYNAMIC = 'redux-frontend/info/LOAD_COMBINED_DYNAMIC';
var LOAD_COMBINED_DYNAMIC_SUCCESS = 'redux-frontend/info/LOAD_COMBINED_DYNAMIC_SUCCESS';
var LOAD_COMBINED_DYNAMIC_FAIL = 'redux-frontend/info/LOAD_COMBINED_DYNAMIC_FAIL';

var LOAD_COMBINED_STATIC = 'redux-frontend/info/LOAD_COMBINED_STATIC';
var LOAD_COMBINED_STATIC_SUCCESS = 'redux-frontend/info/LOAD_COMBINED_STATIC_SUCCESS';
var LOAD_COMBINED_STATIC_FAIL = 'redux-frontend/info/LOAD_COMBINED_STATIC_FAIL';

var LOAD_PRESET_ACT = 'redux-frontend/info/LOAD_PRESET_ACT';
var LOAD_PRESET_ACT_SUCCESS = 'redux-frontend/info/LOAD_PRESET_ACT_SUCCESS';
var LOAD_PRESET_ACT_FAIL = 'redux-frontend/info/LOAD_PRESET_ACT_FAIL';

var LOAD_SITE_MAP = 'redux-frontend/info/LOAD_SITE_MAP';
var LOAD_SITE_MAP_SUCCESS = 'redux-frontend/info/LOAD_SITE_MAP_SUCCESS';
var LOAD_SITE_MAP_FAIL = 'redux-frontend/info/LOAD_SITE_MAP_FAIL';

var initialState = {
  destinations: {},
  exchangeRates: {},
  stations: {},
  stationsLoaded: false,
  arlLoaded: false,
  mrtLoaded: false,
  btsLoaded: false,
  exchangeRatesLoaded: false,
  destinationsLoaded: false,
  activeLanguages: [],
  activeLanguagesLoaded: false,
  activitiesLoaded: false,
  userConfigLoaded: false,
  activities: [],
  forms: [],
  formsLoaded: false,
  userConfig: {},
  siteConfigs: {
    removeSearchFeature: false,
    tripHideLx: false
  },
  headTags: {},
  headTagsLoaded: false,
  topActivities: [],
  topActivitiesLoaded: false,
  combinedStaticLoaded: false,
  presetActivities: [],
  presetActivitiesLoaded: false,
  siteMapDestinations: {},
  articles: [],
  countrySite: process.env.COUNTRY || 'en'
  // combinedDynamicLoaded: false,
};

function info() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_ACTIVITIES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        activities: action.result.activities,
        activitiesLoaded: true
      });
    case LOAD_DEST_SUCCESS:
      return (0, _extends3.default)({}, state, {
        destinations: (0, _trip.convertToDestinationArray)(action.result),
        destinationsLoaded: true
      });
    case LOAD_FORMS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        forms: action.result.forms,
        formsLoaded: true
      });
    case LOAD_EXCHANGE_RATES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        exchangeRates: action.result,
        exchangeRatesLoaded: true
      });
    case LOAD_LANGUAGES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        activeLanguages: ['Any'].concat((0, _toConsumableArray3.default)(action.result.activeLanguages)),
        activeLanguagesLoaded: true
      });
    case LOAD_STATIONS_SUCCESS:
      if (action.result.arl) {
        return (0, _extends3.default)({}, state, {
          stations: (0, _extends3.default)({}, state.stations, { arl: action.result.arl }),
          arlLoaded: true
        });
      }
      if (action.result.bts) {
        return (0, _extends3.default)({}, state, {
          stations: (0, _extends3.default)({}, state.stations, { bts: action.result.bts }),
          btsLoaded: true
        });
      }
      if (action.result.mrt) {
        return (0, _extends3.default)({}, state, {
          stations: (0, _extends3.default)({}, state.stations, { mrt: action.result.mrt }),
          mrtLoaded: true
        });
      }
      return state;
    case LOAD_USER_CONFIG:
      return (0, _extends3.default)({}, state);
    case LOAD_USER_CONFIG_SUCCESS:
      return (0, _extends3.default)({}, state, {
        userConfig: action.result,
        userConfigLoaded: true
      });
    case LOAD_USER_CONFIG_FAIL:
      return (0, _extends3.default)({}, state, {
        userConfigLoaded: false
      });
    case LOAD_SITE_CONFIGS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        siteConfigs: action.result.siteConfigs,
        siteConfigsLoaded: true
      });
    case LOAD_SITE_CONFIGS_FAIL:
      return (0, _extends3.default)({}, state, {
        siteConfigsLoaded: false
      });
    case LOAD_TOP_ACTIVITIES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        topActivities: action.result.topActivities,
        topActivitiesLoaded: true
      });
    case LOAD_PRESET_ACT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        presetActivities: _lodash2.default.shuffle(action.result.presetActivities),
        presetActivitiesLoaded: true
      });
    case LOAD_COMBINED_DYNAMIC_SUCCESS:
      return (0, _extends3.default)({}, state, {
        userConfig: action.result.userConfigs,
        userConfigLoaded: true
      });
    case LOAD_COMBINED_STATIC_SUCCESS:
      var locale = action.locale || 'en';
      return (0, _extends3.default)({}, state, {
        // siteConfigs: action.result.siteConfigs,
        // siteConfigs: require('json/site-configs.json'),
        siteConfigs: _siteConfigs2.default[locale],
        siteConfigsLoaded: true,
        // destinations: convertToDestinationArray(action.result.destinations),
        // destinations: convertToDestinationArray(require('json/destinations.json')),
        destinations: (0, _trip.convertToDestinationArray)(_destinations2.default[locale]),
        destinationsLoaded: true,
        exchangeRates: action.result.exchangeRates.rates,
        // exchangeRates: action.result.exchangeRates,
        exchangeRatesLoaded: true,
        // activeLanguages: ['Any', ...action.result.languages],
        // activeLanguages: ['Any', ...require('json/languages.json')],
        activeLanguages: ['Any'].concat((0, _toConsumableArray3.default)(_languages2.default[locale])),
        activeLanguagesLoaded: true,
        // activities: action.result.activities,
        // activities: require('json/activities.json'),
        activities: _activities2.default[locale],
        activitiesLoaded: true,
        // headTags: action.result.headTags || {},
        // headTags: require('json/head-tags.json'),
        headTags: _headTags2.default[locale] || {},
        headTagsLoaded: true,
        combinedStaticLoaded: true
      });
    case LOAD_SITE_MAP_SUCCESS:
      return (0, _extends3.default)({}, state, {
        siteMapDestinations: (0, _trip.convertToDestinationArray)(action.result)
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.info && globalState.info.loaded;
}

function load() {
  return {
    types: [LOAD_DEST, LOAD_DEST_SUCCESS, LOAD_DEST_FAIL],
    promise: function promise(client) {
      return client.get('/info/destinations');
    }
  };
}

function loadExchangeRates() {
  return {
    types: [LOAD_EXCHANGE_RATES, LOAD_EXCHANGE_RATES_SUCCESS, LOAD_EXCHANGE_RATES_FAIL],
    promise: function promise(client) {
      return client.get('/info/exchange-rates');
    }
  };
}
// export function loadStations() {
//   return {
//     types: [LOAD_STATIONS, LOAD_STATIONS_SUCCESS, LOAD_STATIONS_FAIL],
//     promise: (client) => client.get('/configs/meeting-points')
//     .then((result)=> {
//       const meetingPoints = result;
//       const bangkok = _.find(meetingPoints, {city: 'Bangkok'});
//       return Promise.resolve({
//         stations: bangkok.points.reduce((prev, curr)=>{
//           if (curr.type === 'Airport Rail Link Station' && curr.name !== 'Any Station') {
//             return {...prev, arl: [...prev.arl, {text: curr.name, id: curr._id}]};
//           }
//           if (curr.type === 'BTS Station' && curr.name !== 'Any Station') {
//             return {...prev, bts: [...prev.bts, {text: curr.name, id: curr._id}]};
//           }
//           if (curr.type === 'MRT Station' && curr.name !== 'Any Station') {
//             return {...prev, mrt: [...prev.mrt, {text: curr.name, id: curr._id}]};
//           }
//           return prev;
//         }, {arl: [], mrt: [], bts: []})
//       });
//     })
//   };
// }
function loadARL() {
  return {
    types: [LOAD_STATIONS, LOAD_STATIONS_SUCCESS, LOAD_STATIONS_FAIL],
    promise: function promise(client) {
      return client.get('/configs/meeting-points?city=Bangkok&type=Airport Rail Link Station').then(function (result) {
        var bangkok = result[0];
        return _promise2.default.resolve({
          arl: bangkok.points
        });
      });
    }
  };
}

function loadBTS() {
  return {
    types: [LOAD_STATIONS, LOAD_STATIONS_SUCCESS, LOAD_STATIONS_FAIL],
    promise: function promise(client) {
      return client.get('/configs/meeting-points?city=Bangkok&type=BTS Station').then(function (result) {
        var bangkok = result[0];
        return _promise2.default.resolve({
          bts: bangkok.points
        });
      });
    }
  };
}

function loadMRT() {
  return {
    types: [LOAD_STATIONS, LOAD_STATIONS_SUCCESS, LOAD_STATIONS_FAIL],
    promise: function promise(client) {
      return client.get('/configs/meeting-points?city=Bangkok&type=MRT Station').then(function (result) {
        var bangkok = result[0];
        return _promise2.default.resolve({
          mrt: bangkok.points
        });
      });
    }
  };
}

function loadLanguages() {
  return {
    types: [LOAD_LANGUAGES, LOAD_LANGUAGES_SUCCESS, LOAD_LANGUAGES_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=activeLanguages');
    }
  };
}

function loadForms() {
  return {
    types: [LOAD_FORMS, LOAD_FORMS_SUCCESS, LOAD_FORMS_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=forms');
    }
  };
}

function loadActivities() {
  return {
    types: [LOAD_ACTIVITIES, LOAD_ACTIVITIES_SUCCESS, LOAD_ACTIVITIES_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=activities');
    }
  };
}

function loadUserConfig() {
  return {
    types: [LOAD_USER_CONFIG, LOAD_USER_CONFIG_SUCCESS, LOAD_USER_CONFIG_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=userConfigs');
    }
  };
}

function loadSiteConfigs() {
  return {
    types: [LOAD_SITE_CONFIGS, LOAD_SITE_CONFIGS_SUCCESS, LOAD_SITE_CONFIGS_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=siteConfigs');
    }
  };
}

function loadTopActivities() {
  return {
    types: [LOAD_TOP_ACTIVITIES, LOAD_TOP_ACTIVITIES_SUCCESS, LOAD_TOP_ACTIVITIES_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=topActivities');
    }
  };
}

function loadCombinedDynamic() {
  return {
    types: [LOAD_COMBINED_DYNAMIC, LOAD_COMBINED_DYNAMIC_SUCCESS, LOAD_COMBINED_DYNAMIC_FAIL],
    promise: function promise(client) {
      return client.get('/combined/dynamic');
    }
  };
}

function loadCombinedStatic(locale) {
  return {
    types: [LOAD_COMBINED_STATIC, LOAD_COMBINED_STATIC_SUCCESS, LOAD_COMBINED_STATIC_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=exchangeRates');
    },
    // promise: (client) => client.get('/combined/static'),
    locale: locale
  };
}

function loadPresetActivities() {
  return {
    types: [LOAD_PRESET_ACT, LOAD_PRESET_ACT_SUCCESS, LOAD_PRESET_ACT_FAIL],
    promise: function promise(client) {
      return client.get('/configs?keys=presetActivities');
    }
  };
}

function loadDestinationsSiteMap() {
  return {
    types: [LOAD_SITE_MAP, LOAD_SITE_MAP_SUCCESS, LOAD_SITE_MAP_FAIL],
    promise: function promise(client) {
      return client.get('/info/active-destinations');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/info.js
// module id = 147
// module chunks = 47